<template>
  <BasicMoviePlayer
    ref="refMoviePlayerVideo"
    :movie-lists="movieLists"
    :movie-list-id="movieListId"
    :extreme-map-essentials="extremeMapEssentials"
    :parent-geo-items-meta="parentGeoItemsMeta"
    @close="emitCloseEvent"
    @switch-to-compare-mode="emitSwitchToCompareMode"
  />
</template>

<script setup lang="ts">

import { ref } from 'vue';
import BasicMoviePlayer from 'src/components/lib/MoviePlayer/BasicMoviePlayer/index.vue';
import type { GeoItemsMeta, GIMovieList } from 'src/models/geoItem';
import type { ExtremeMapEssentials } from 'src/models';
import type { MoviePlayerParams } from 'src/models/moviePlayer';

interface Props {
  movieLists: Array<GIMovieList>;
  movieListId: string | null;
  extremeMapEssentials: ExtremeMapEssentials | null;
  parentGeoItemsMeta: GeoItemsMeta;
}

defineProps<Props>();

const emit = defineEmits<{
  (e: 'close'): void;
  (e: 'switch-to-compare-mode', payload: MoviePlayerParams): void;
}>();

const emitCloseEvent = () => {
  emit('close');
};
const emitSwitchToCompareMode = (e: MoviePlayerParams) => {
  emit('switch-to-compare-mode', e);
};
// Topからの制御をそのまま渡すため。
const refMoviePlayerVideo = ref<InstanceType<typeof BasicMoviePlayer>>();
const shortcutKeyAction = (key: string) => {
  if (!refMoviePlayerVideo.value) return;

  refMoviePlayerVideo.value.shortcutKeyAction(key);
};

defineExpose({ shortcutKeyAction });
</script>
